$(document).ready(function () {
  
  // BANNER AND EVENT PAGE SLIDER
  $(".custom_bannner_head,.event_featured_collection_grid").slick({ 
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    dots: false,
      prevArrow:
      '<span class="Arrowleft slide_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></span>',
    nextArrow:
      '<span class="ArrowRight slide_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></span>',
  });

});

document.addEventListener("DOMContentLoaded", () => {
   let hambergerIcon = document.querySelector('.hamberger_icon');
   let crossIcon = document.querySelector('.cross_icon');
   let headerMenuHead = document.querySelector('.header_menu_head');
   let headerW = document.querySelector('.header_wrapper');

   hambergerIcon.addEventListener('click', function() {
    headerMenuHead.classList.add('header_menu_head_active');
    if(headerMenuHead.classList.contains('header_menu_head_active')){
      crossIcon.classList.add('cross_icon_active');
      hambergerIcon.classList.add('hidden');
    }
  });
  
  crossIcon.addEventListener('click', function() {
     headerMenuHead.classList.remove('header_menu_head_active');
      hambergerIcon.classList.remove('hidden');
      crossIcon.classList.remove('cross_icon_active');
  });

  // GALLREY-BOX SCROLL TOP TOP
  let selectPhotoItem = document.querySelectorAll('.select_photo_item');
  selectPhotoItem.forEach(function (Item) {
    Item.addEventListener('click',function() {
        function scorllTopImageBox() {
            document.querySelector('.photo_from_gallery_box').scroll({top:0,behavior:'smooth'});
        }
        setTimeout(scorllTopImageBox, 200);
    });
  });


  // // MAIN-PRODUCT INK COLOR
  let inkColorHeadingAll = document.querySelectorAll('.select_ink_color_heading_head');
  let selectInkColorAll = document.querySelectorAll('.select_ink_color_inner');
  let selectInkColorLabelAll = document.querySelectorAll('.select_ink_color_label');
  let customInkColorBtnAll = document.querySelectorAll('#custom_ink_color_btn');
  
  selectInkColorAll.forEach(function(selectInkColor) {
    let inkColorHeading = selectInkColor.querySelector('.select_ink_color_heading_head');
    let selectInkColorGrid = selectInkColor.querySelector('.select_ink_color_grid');
    
    // Show grid on heading click
    inkColorHeading.addEventListener('click', () => {
      selectInkColorGrid.classList.add('select_ink_color_grid_active');
    });
  });
  
  selectInkColorLabelAll.forEach(function(selectInkColorLabel) {
    selectInkColorLabel.addEventListener('click', function() {
      let parent = selectInkColorLabel.closest('.select_ink_color_inner'); // Find the parent
      let selectInkColorGrid = parent.querySelector('.select_ink_color_grid'); // Get the associated grid
      selectInkColorGrid.classList.remove('select_ink_color_grid_active');
    });
  });
  
  customInkColorBtnAll.forEach(function(customInkColorBtn) {
    customInkColorBtn.addEventListener('click', function() {
      let parent = customInkColorBtn.closest('.select_ink_color_inner'); // Find the parent
      let selectInkColorGrid = parent.querySelector('.select_ink_color_grid'); // Get the associated grid
      selectInkColorGrid.classList.remove('select_ink_color_grid_active');
    });
  });


    // product page character count js

  document.querySelectorAll('.autograph_location_field textarea.add_on_field').forEach(function (elem) {
    elem.addEventListener("input",function (e) {
      let wordRemainElem = e.target.closest(".autograph_location_field")?.querySelector("#word_remain");
      if (wordRemainElem) {
        wordRemainElem.innerText = e.target.value.length;
        
      }
    })
  })

   // collection page search filter js

  document.getElementById("collectionSearch")?.addEventListener("input", function (e) {
    
      let search = e.target.value.toLowerCase().trim();
      let searchLength = e.target.value.length;
    
      let items = document.querySelectorAll(".collection ul .grid__item");
      let noResults = document.querySelector(".no_results");
      let hasVisibleItems = false; 
  
      if (search !== '') {
          items.forEach(function (elem) {
              let prodTitle = elem.getAttribute("data-title").toLowerCase();
              if (prodTitle.includes(search)) {
                  elem.classList.remove("hidden");
                  hasVisibleItems = true;
              } else {
                  elem.classList.add("hidden");
              }
          });
  
          if (!hasVisibleItems) {
              noResults.style.display = "block";
          } else {
              noResults.style.display = "none";
          }
  
      } else {
          items.forEach(el => {
              el.classList.remove("hidden");
          });
          noResults.style.display = "none";
      }
  });


  // collection page search filter js


  // sort by fandom js
  

   var items = Array.from(document.querySelectorAll(".collection ul .grid__item")); 
   var dupItemsArr = items.slice() ;  

  document.querySelectorAll("#SortByFandom").forEach(function (elem) {
    elem.addEventListener("change", sortByFandomFnc);
  })
    
  
  function sortByFandomFnc() {

      document.querySelector(".product-grid-container").classList.add("overlay") ;
      document.querySelector(".product-grid-container .loader").style.visibility = 'visible' ;
  
      setTimeout(()=>{
         document.querySelector(".product-grid-container").classList.remove("overlay") ;
         document.querySelector(".product-grid-container .loader").style.visibility = 'hidden' ;
      },800);

      let selectedTag = this.value.toLowerCase();

      // console.log(selectedTag) ;
      
      let itemsContainer = document.querySelector(".collection ul");
      let sortByselect = document.getElementById("SortBy"); 
  
      // console.log("Selected Sort Option:", sortByselect.value);
  
      if (selectedTag === '' ) {
          itemsContainer.innerHTML = "";
          dupItemsArr.forEach(item => itemsContainer.appendChild(item));
          return;
      }

      items = Array.from(document.querySelectorAll(".collection ul .grid__item"))
  
      let matchingItems = [];
      let nonMatchingItems = [];
  
      items.forEach(item => {
          let tags = item.getAttribute("data-tags")?.toLowerCase() || "";
          if (tags.includes(selectedTag)) {
              matchingItems.push(item);
          } else {
              nonMatchingItems.push(item);
          }
      });
  
      itemsContainer.innerHTML = "";
      matchingItems.forEach(item => itemsContainer.appendChild(item));
      nonMatchingItems.forEach(item => itemsContainer.appendChild(item));

      // console.log(itemsContainer) ;
     
      if (sortByselect.value !== "manual" && selectedTag === '') {
          // console.log("Triggering sorting after filtering...");
          location.reload();
      }
  }

  
   // sort by fandom js


  
});


